'use client'

import analytics, { PosthogBootstrapDataCookieValue } from 'product-analytics'
import { ReactNode } from 'react'
import getIsProduction from '@/helpers/utils/getIsProduction'

const shouldRunInThisEnvironment =
  !!process.env.NEXT_PUBLIC_ENABLE_POSTHOG ||
  (process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT !== 'test')

const debug = !getIsProduction()

function ClientAnalyticsProvider({
  apiKey = '',
  bootstrapData,
  children,
}: {
  bootstrapData?: PosthogBootstrapDataCookieValue
  children: ReactNode
  apiKey: string | undefined
}) {
  // !!WARNING!! This will run on every render, so make sure to early exit in initialize
  analytics.initialize({
    bootstrapData,
    apiKey,
    debug,
    enable: typeof window !== 'undefined' && shouldRunInThisEnvironment,
  })
  return children
}

export default ClientAnalyticsProvider
